<div class="qq-container fw-Header" *ngIf="showQuickQuote">
  <button
    class="fw-Header_Icons"
    mat-icon-button
    *ngIf="!showSearchPrompt"
    (click)="renderSearch(true)"
    matTooltip="{{ 'QUICK_QUOTE' | translate }}"
    attr.aria-label="{{ 'QUICK_QUOTE' | translate }}"
  >
    <mat-icon class="fw-Header_SearchIcon fa fa-search center"></mat-icon>
  </button>
  <quick-quote-search
    *ngIf="showSearchPrompt"
    (showSearchPromptEvent)="renderSearch($event)"
  ></quick-quote-search>
</div>
